import {isNil} from 'ramda';

import type {Nullish} from 'shared/web';

export function calculateReportPercentage(amount: number | Nullish, base: number | Nullish) {
  if (
    isNil(amount) ||
    isNil(base) ||
    !Number.isFinite(amount) ||
    !Number.isFinite(base) ||
    base <= 0
  ) {
    return null;
  }
  return (amount / base) * 100;
}
